export default __webpack_public_path__ + "static/media/illustration-study-3-m.98aaf55f.webp";